/**
 * DASHBOARD-RPS-USERS-SKELETON.WIDGET
 * Skeleton adapté à dashboard-rps-users.widget.tsx : texte d'intro, puis le quadrant
 * Karasek (axes Stress/Autonomie, teintes rouge/vert par zone, croix pointillée, nuage
 * de points de tailles variées), avec un reflet qui balaie. Le graphique réel est en
 * Plotly (non animable via nos hooks) — skeleton uniquement, mais avec les mêmes repères
 * de lecture (axes, zones) pour ne pas paraître trop générique pendant le chargement.
 */
import { t } from "i18next"
import Skeleton, { SkeletonShine } from "@/components/skeleton"

//Positions + tailles (% de la zone) qui rappellent un nuage de points réparti sur les 4
//quadrants, avec quelques points plus gros (comme les bulles à plusieurs individus)
const DOTS: [number, number, number][] = [
  [18, 22, 16],
  [30, 15, 14],
  [22, 38, 18],
  [40, 30, 14],
  [65, 20, 14],
  [78, 12, 16],
  [70, 35, 20],
  [85, 28, 14],
  [25, 68, 16],
  [38, 78, 22],
  [20, 85, 14],
  [45, 62, 18],
  [68, 70, 16],
  [80, 82, 24],
  [72, 60, 14],
  [90, 75, 16],
  [50, 48, 20],
  [55, 55, 16]
]

export default function DashboardRpsUsersSkeletonWidget() {
  return (
    <div className="rel" style={{ overflow: "hidden" }}>
      <Skeleton width={280} height={13} style={{ marginBottom: 10 }} />
      <Skeleton width={320} height={13} style={{ marginBottom: 24 }} />

      <div className="flex" style={{ width: "100%", maxWidth: 680, margin: "0 auto" }}>
        <div
          className="flex flex-dcol items-center grey-t"
          style={{ width: 36, justifyContent: "space-between", padding: "4px 0" }}>
          <span style={{ fontSize: 13 }}>{t("rps_axis_high")}</span>
          <span style={{ fontSize: 13, fontWeight: "bold", writingMode: "vertical-rl", transform: "rotate(180deg)" }}>
            {t("rps_axis_stress")}
          </span>
          <span style={{ fontSize: 13 }}>{t("rps_axis_low")}</span>
        </div>

        <div className="flex1">
          <div className="rel" style={{ width: "100%", height: 420 }}>
            <Skeleton width="100%" height="100%" borderRadius={8} />

            {/* Teinte des zones : rouge pâle = stress élevé + autonomie basse, vert pâle = l'inverse */}
            <div
              className="abs"
              style={{ left: 0, top: 0, width: "50%", height: "50%", background: "rgba(235,90,70,0.06)" }}
            />
            <div
              className="abs"
              style={{ right: 0, bottom: 0, width: "50%", height: "50%", background: "rgba(32,202,126,0.08)" }}
            />

            {/* Croix de séparation des quadrants */}
            <div
              className="abs"
              style={{
                left: "50%",
                top: "3%",
                width: 0,
                height: "94%",
                borderLeft: "1px dashed #cfcfcf"
              }}
            />
            <div
              className="abs"
              style={{
                top: "50%",
                left: "3%",
                width: "94%",
                height: 0,
                borderTop: "1px dashed #cfcfcf"
              }}
            />

            {DOTS.map(([x, y, size], i) => (
              <div key={i} className="abs" style={{ left: `${x}%`, top: `${y}%` }}>
                <Skeleton width={size} height={size} isCircle />
              </div>
            ))}
          </div>

          <div className="flex grey-t" style={{ marginTop: 10 }}>
            <span style={{ fontSize: 13 }}>{t("rps_axis_low")}</span>
            <div className="flex1" />
            <b style={{ fontSize: 13 }}>{t("rps_axis_autonomy")}</b>
            <div className="flex1" />
            <span style={{ fontSize: 13 }}>{t("rps_axis_high")}</span>
          </div>
        </div>
      </div>

      <SkeletonShine />
    </div>
  )
}
